import React, { useState } from "react";

import Loader from "./../Category/components/Loader";
import LayeredUnitImage from "./LayeredUnitImage";
import {
    defaultColor,
} from "./../Category/Heroes/components/FantasyHeroCategoryStyles";

function FantasyNPCUnitImage(args) {
    const [isLoading, setIsLoading] = useState(true);

    return (
        <>
        {isLoading ? <Loader pixelColor={defaultColor} /> : null}
        <LayeredUnitImage
            // isRegular
            {...args}
            onLoad={() => setIsLoading(false)}
        />
        </>
    );
}

export default FantasyNPCUnitImage;
